<template>
  <div class="container2">
    <!-- 展商信息 -->
    <div class="row1">
      <div class="exhibitor">
        <div class="title">
          <button @click="editExhi">{{ $t("home.editInfo") }}</button>
        </div>
        <div class="content">
          <div class="name">
            <span class="name1">{{ baseInfo.name }}</span>
            <span class="name2">{{ baseInfo.named }}</span>
          </div>
          <div class="info1">
            <div class="infoCom">
              <span class="label">{{ $t("home.company") }}</span
              ><span class="value">{{ baseInfo.company }}</span>
            </div>
            <div class="infoPhone">
              <span class="label">{{ $t("common.phone") }}</span
              ><span class="value">{{ baseInfo.registAccount }}</span>
            </div>
          </div>
          <div class="info2">
            <div class="infoCom">
              <span class="label">{{ $t("home.address") }}</span
              ><span class="value">{{ baseInfo.address }}</span>
            </div>
            <div class="infoPhone">
              <span class="label">{{ $t("common.email") }}</span
              ><span class="value">{{ baseInfo.email }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="infor">
        <h3>{{ $t("home.statistics") }}</h3>
        <div class="shujv">
          <div class="box1">
            {{ $t("Favorites.collentExhibitors") }}
            <h2>{{ number.zs }}</h2>
          </div>
          <div class="box1">
            {{ $t("Favorites.collentExhibits") }}
            <h2>{{ number.zp }}</h2>
          </div>

          <div class="box1">
            {{ $t("Favorites.collentLive") }}
            <h2>{{ number.zb }}</h2>
          </div>
          <div class="box1 lastBox1">
            {{ $t("Favorites.collentActive") }}
            <h2>{{ number.hd }}</h2>
          </div>
        </div>
      </div>
    </div>

    <!-- 推荐产品 -->
    <div class="row2">
      <div class="title">
        <h3>{{ $t("common.recommend.exhibits") }}</h3>
        <div class="button">
          <div class="all" @click="viewProduct()">
            {{ $t("common.viewAll") }}
          </div>
        </div>
      </div>
      <div class="product">
        <div
          v-for="(item, index) in productLists"
          :key="index"
          class="procuct_box"
          @click="goProductDetail(item)"
        >
          <div class="titl comment">{{ item.exhibitsName }}</div>
          <div class="english comment">{{ item.column23 }}</div>
          <div class="txt">{{ item.column17 }}</div>
          <div class="backImg">
            <img
              :src="baseUrl + item.exhibitsCoverImg"
              alt=""
              v-if="item.exhibitsCoverImg.includes('/')"
            />
            <img src="../../static/占位-展品-列表.png" alt="" v-else />
          </div>
          <div class="companyName">
            <span class="leftTitle">{{ item.hzExhibitor.companyNameC }}</span>
          </div>
        </div>

        <!--显示空数据-->
        <div v-show="productLists.length <= 0" class="nodata">
          <div>
            <img alt="" src="../../static/nodata.png" />
          </div>
          <div class="tip">
            <p>{{ $t("common.tips.exhibits") }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 推荐直播 -->
    <div class="row3">
      <div class="live">
        <div class="title">
          <h3>{{ $t("common.recommend.live") }}</h3>
          <div class="button">
            <button class="all" @click="viewLive()">
              {{ $t("common.viewAll") }}
            </button>
          </div>
        </div>
        <div class="active_box">
          <div
            v-for="(item, index) in liveLists"
            :key="index"
            class="active_content"
            @click="goLiveDetail(item)"
          >
            <div class="vedio">
              <img
                :src="baseUrl + item.coverPhoto"
                class="fengmian"
                alt=""
                v-if="item.coverPhoto.includes('.')"
              />
              <img
                src="../../static/占位-直播-列表.png"
                class="fengmian"
                alt=""
                v-else
              />
            </div>
            <p class="name" :title="item.liveCn">{{ item.liveCn }}</p>
            <p class="imgLive">
              <img src="../../static/ico-time.png" alt="" /><span>{{
                item.startDate
              }}</span>
            </p>
            <p class="namezs">
              <span>{{ item.exhibitorNameCn }}</span>
            </p>
          </div>

          <!--显示空数据-->
          <div v-show="liveLists.length <= 1" class="nodata">
            <div>
              <img alt="" src="../../static/nodata.png" />
            </div>
            <div class="tip">
              <p>{{ $t("common.tips.live") }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="mine">
        <div class="title">
          <h3>{{ $t("common.myMessage") }}</h3>
          <div class="button">
            <button class="all" @click="viewMessage()">
              {{ $t("common.viewAll") }}
            </button>
          </div>
        </div>
        <div v-for="(item, index) in messageLists" :key="index" class="xinxi">
          <div class="name">
            <span class="left" :title="item.companyNameC">{{
              item.companyNameC
            }}</span>
            <span class="right">{{ item.time.slice(0, 10) }}</span>
          </div>
          <div class="content">
            {{ item.content }}
          </div>
        </div>
        <div v-if="messageLists.length < 1" class="nodata">
          <div>
            <img alt="" src="../../static/nodata.png" />
          </div>
          <div class="tip">
            <p>{{ $t("common.tips.message") }}</p>
          </div>
          <div class="button" @click="consult()">
            {{ $t("common.consult") }}
          </div>
        </div>
      </div>
    </div>
    <!-- 推荐活动 -->
    <div class="row4">
      <div class="title">
        <h3>{{ $t("common.recommend.activity") }}</h3>
        <div class="button">
          <div class="all" @click="viewActivity()">
            {{ $t("common.viewAll") }}
          </div>
        </div>
      </div>
      <div class="activity">
        <div
          v-for="(item, index) in activityLists"
          :key="index"
          class="activity_box"
          @click="goActivityDetail(item)"
        >
          <div class="img">
            <img :src="baseUrl + item.column15" alt="" v-if="item.column15" />
            <img src="../../static/占位-活动-列表.png" alt="" v-else />
          </div>

          <div class="name">{{ item.actTitle }}</div>
          <p class="time">
            <img src="../../static/ico-time.png" alt="" /><span>{{
              item.startTime
            }}</span>
          </p>
          <p class="zw">
            <img src="../../static/ico_address.png" align="absmiddle" /><span
              class="address"
              >{{ item.address }}</span
            >
          </p>
          <div class="companyName">{{ item.hzExhibitor.companyNameC }}</div>
        </div>

        <!--显示空数据-->
        <div v-show="activityLists.length <= 0" class="nodata">
          <div>
            <img alt="" src="../../static/nodata.png" />
          </div>
          <div class="tip">
            <p>{{ $t("common.tips.activity") }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="alert_mess" v-show="visible">
      <img class="close" @click="close" src="../../static/close.png" />
      <div class="qrcode">
        <img :src="baseUrl + livePhoto" alt="" />
      </div>
      <p>{{ $t("common.qrCode") }}</p>
    </div>
  </div>
</template>

<script>
import {
  forMat,
  backProductDetail,
  backActivityDetail,
  backLiveDetail,
  backExhibitionList,
} from "../../../utils/common.js";
import { getInfo } from "../../../api/personInfo.js";
import {
  getProductsLists,
  getLiveLists,
  getActivityLists,
} from "../../../api/recommend.js";
import { getLists } from "../../../api/message.js";
import {
  getExLists,
  getColProductsLists,
  getColLiveLists,
  getColActivityLists,
} from "../../../api/collection.js";
export default {
  data() {
    return {
      baseUrl: forMat(),
      number: {
        zs: "",
        zp: "",
        zb: "",
        hd: "",
      },
      baseInfo: {},
      productLists: [],
      liveLists: [],
      messageLists: [],
      activityLists: [],
      screenWidth: "",
      productDetailUrl: backProductDetail(),
      activityDetailUrl: backActivityDetail(),
      liveDetailUrl: backLiveDetail(),
      exhibitonUrl: backExhibitionList(),
      visible: false,
      livePhoto: "",
    };
  },
  created() {
    this.initListData();
    this.initColData();
  },
  methods: {
    consultzs() {
      // 跳转至线上展会列表
      window.location.href = this.exhibitonUrl;
    },
    close() {
      this.visible = false;
    },
    goLiveDetail(item) {
      switch (item.videoType) {
        case "1":
          // 视频 跳详情页
          window.location.href = this.liveDetailUrl + "?userId=" + item.id;
          break;

        case "2":
          // 直播外链 打开新窗口
          window.open(item.videoAddress);
          break;

        case "3":
          //  二维码 弹窗
          this.visible = true;
          this.livePhoto = item.videoAddress;
          break;
      }
    },
    goActivityDetail(item) {
      window.location.href = this.activityDetailUrl + "?id=" + item.id;
    },
    goProductDetail(item) {
      window.location.href = this.productDetailUrl + "?id=" + item.id;
    },
    initListData() {
      this.getExhibitor();
      this.getProducts();
      this.getLives();
      this.getMessage();
      this.getActivitys();
    },
    initColData() {
      this.getColzs();
      this.getColzp();
      this.getColzb();
      this.getColhd();
    },
    viewActivity() {
      this.$router.push({ name: "recommendInfo", query: { tab: "4" } });
    },
    viewLive() {
      this.$router.push({ name: "recommendInfo", query: { tab: "3" } });
    },
    viewMessage() {
      this.$router.push("/backIndex/myMessage");
    },
    viewProduct() {
      this.$router.push({ name: "recommendInfo", query: { tab: "2" } });
    },
    editExhi() {
      this.$router.push("/backIndex/personInfo");
    },
    async getColzs() {
      const params = {
        keyword: "",
      };
      try {
        const { data } = await getExLists(params);
        if (data.code === 200) {
          this.number.zs = data.data.length;
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    async getColzp() {
      const params = {
        keyword: "",
      };
      try {
        const { data } = await getColProductsLists(params);
        if (data.code === 200) {
          this.number.zp = data.data.length;
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    async getColzb() {
      try {
        const { data } = await getColLiveLists();
        if (data.code === 200) {
          this.number.zb = data.data.length;
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    async getColhd() {
      try {
        const { data } = await getColActivityLists();
        if (data.code === 200) {
          this.number.hd = data.data.length;
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    async getExhibitor() {
      try {
        const { data } = await getInfo();
        if (data.code === 200) {
          this.baseInfo = data.data;
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    async getProducts() {
      const params = {
        value: {
          exhibitsType: [],
          keyword: "",
        },
      };
      try {
        const { data } = await getProductsLists(params);
        if (data.code === 200) {
          this.productLists = data.data.list.slice(0, 5);
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    async getLives() {
      try {
        const { data } = await getLiveLists();
        if (data.code === 200) {
          this.liveLists = data.data.list.slice(0, 3);
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    async getMessage() {
      try {
        const { data } = await getLists();
        if (data.code === 200) {
          this.messageLists = data.data.slice(0, 3);
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    async getActivitys() {
      try {
        const { data } = await getActivityLists();
        if (data.code === 200) {
          this.activityLists = data.data.list.slice(0, 5);
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
  },
  mounted() {
    const that = this;
    window.addEventListener("setItemEvent", function(e) {
      if (e.key == "collentChange") {
        that.initColData();
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.container2 {
  margin-right: 9px;
  background: #f0f2f5;
  .row1 {
    // width: 100%;
    display: flex;
    height: 217px;

    .exhibitor {
      width: 50%;
      margin-right: 26px;
      box-sizing: border-box;
      padding: 17px 26px 26px 0;
      background: white;
      .title {
        text-align: right;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 0 9px 26px;
        border-bottom: 1px solid #e9e9e9;

        button {
          width: 88px;
          height: 32px;
          border: none;
          background: #006fb8;
          color: white;
          border-radius: 4px;
          cursor: pointer;
        }
      }

      .content {
        padding-top: 20px;
        padding-left: 30px;
        box-sizing: border-box;
        width: 100%;
        .label {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
        }
        .value {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 22px;
        }
        .name {
          font-weight: 700;
          color: #333333;
          .name2 {
            margin-left: 10px;
          }
        }
        .info1 {
          margin-top: 30px;
          display: flex;
          .infoCom {
            width: 50%;
          }
          .infoPhone {
            width: 50%;
          }
        }
        .info2 {
          margin-top: 10px;
          display: flex;
          .infoCom {
            width: 50%;
          }
          .infoPhone {
            width: 50%;
          }
        }
      }
    }

    .infor {
      width: 50%;
      min-width: 514px;
      box-sizing: border-box;
      background: white;

      h3 {
        border-bottom: 1px solid #e9e9e9;
        box-sizing: border-box;
        padding: 18px 0 11px 26px;
      }
      .shujv {
        display: flex;
        height: 68px;
        margin: 44px 52px 34px 37px;
        justify-content: space-around;
        .box1 {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 17px;
          text-align: center;
          border-right: 1px solid #e9e9e9;

          flex: 1;
          h2 {
            margin-top: 17px;
            font-size: 26px;
            font-family: HelveticaNeue-Medium, HelveticaNeue;
            font-weight: 500;
            color: #333333;
            line-height: 33px;
          }
        }
        .lastBox1 {
          border-right: none;
        }
      }
    }
  }
  .row2 {
    width: 100%;
    box-sizing: border-box;
    padding: 0px 0 26px 0;
    margin-top: 26px;
    background: white;

    .title {
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 15px 16px 9px 26px;
      border-bottom: 1px solid #e9e9e9;

      .button {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 19px;

        .all {
          width: 88px;
          height: 32px;
          background: #ffffff;
          border: 1px solid #d9d9d9;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 32px;
          text-align: center;
          cursor: pointer;
        }
        .all:hover {
          color: #006fb8;
          border: 1px solid #c4deef;
          border-radius: 4px;
        }

        .add {
          width: 76px;
          height: 28px;
          background: #006fb8;
          border: none;
          margin-left: 9px;
          color: white;
          border-radius: 4px;
        }
      }
    }

    .product {
      display: flex;
      margin-left: 1%;
      width: 100%;
      .procuct_box {
        margin-right: 1%;
        margin-top: 27px;
        width: 18%;
        height: 374px;
        padding: 20px;
        box-sizing: border-box;
        background: #ffffff;
        border: 1px solid #e0e0e0;
        cursor: pointer;
        .titl {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-break: break-all;
          max-width: 250px;
          height: 60px;
        }
        .english {
          font-size: 16px;
          height: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #333333;
          margin-top: 10px;
          line-height: 16px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          max-width: 250px;
        }
        .txt {
          font-size: 14px;
          height: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          margin-top: 11px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          line-height: 14px;
          max-width: 250px;
        }
        .backImg {
          width: 100%;
          height: 172px;
          margin-top: 20px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .companyName {
          margin-top: 5px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .leftTitle {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            width: 225px;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 225px;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .procuct_box:nth-child(5) {
        margin-right: 0;
      }
    }
  }
  .row3 {
    display: flex;
    background: #f0f2f5;
    margin-top: 30px;
    height: 370px;
    .title {
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 15px 16px 9px 26px;
      border-bottom: 1px solid #e9e9e9;

      .button {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 19px;

        .all {
          width: 88px;
          height: 32px;
          background: #ffffff;
          border: 1px solid #d9d9d9;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 32px;
          text-align: center;
          cursor: pointer;
        }
        .all:hover {
          color: #006fb8;
          border: 1px solid #c4deef;
          border-radius: 4px;
        }

        .add {
          width: 76px;
          height: 28px;
          background: #006fb8;
          border: none;
          margin-left: 9px;
          color: white;
          border-radius: 4px;
        }
      }
    }
    .live {
      width: 65%;
      background: white;
      .active_box {
        display: flex;
        padding-left: 30px;
        box-sizing: border-box;
        .active_content {
          width: 30%;
          height: 270px;
          margin-right: 30px;
          margin-top: 20px;
          .vedio {
            width: 100%;
            height: 162px;
            .fengmian {
              width: 100%;
              height: 100%;
            }
          }
          .name {
            margin-top: 10px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            cursor: pointer;
          }
          .imgLive {
            color: #666;
            font-size: 16px;
            margin-top: 10px;
            img {
              width: 14px;
              height: 14px;
              margin-right: 5px;
            }
            span {
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
              line-height: 22px;
            }
          }
          .namezs {
            margin-top: 10px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 22px;
          }
        }
      }
    }

    .mine {
      width: 35%;
      margin-left: 30px;
      background: white;
      .xinxi {
        padding-top: 20px;
        padding-bottom: 15px;
        box-sizing: border-box;
        margin-left: 26px;
        margin-right: 26px;
        height: 89px;
        border-bottom: 1px solid #e9e9e9;
        .name {
          display: flex;
          .left {
            width: 70%;
            // flex: 1;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 22px;
            text-align: left;
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap; //溢出不换行
          }
          .right {
            width: 30%;
            // flex: 1;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 22px;
            text-align: right;
          }
        }

        .content {
          margin-top: 10px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 14px;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  .row4 {
    width: 100%;
    box-sizing: border-box;
    padding: 0px 0 26px 0;
    margin-top: 26px;
    background: white;

    .title {
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 15px 16px 9px 26px;
      border-bottom: 1px solid #e9e9e9;

      .button {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 19px;

        .all {
          width: 88px;
          height: 32px;
          background: #ffffff;
          border: 1px solid #d9d9d9;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 32px;
          text-align: center;
          cursor: pointer;
        }
        .all:hover {
          color: #006fb8;
          border: 1px solid #c4deef;
          border-radius: 4px;
        }

        .add {
          width: 76px;
          height: 28px;
          background: #006fb8;
          border: none;
          margin-left: 9px;
          color: white;
          border-radius: 4px;
        }
      }
    }
    .activity {
      padding-top: 20px;
      margin-left: 3%;
      box-sizing: border-box;
      display: flex;
      .activity_box {
        width: 24%;
        // flex: 1;
        margin-right: 1%;
        cursor: pointer;
        .img {
          width: 100%;
          height: 192px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .name {
          margin-top: 20px;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 22px;
        }
        .time {
          margin-top: 10px;
          img {
            width: 14px;
            height: 14px;
            line-height: 14px;
          }
          span {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            margin-left: 5px;
            line-height: 22px;
          }
        }
        .zw {
          margin-top: 5px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #666;
          line-height: 22px;
          .address {
            font-weight: 600;
            margin-left: 5px;
          }
          img {
            width: 14px;
            height: 14px;
            line-height: 14px;
          }
          span {
            font-weight: 500;
          }
        }
        .companyName {
          margin-top: 10px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 22px;
        }
      }
      .activity_box:nth-child(5) {
        margin-right: 0;
      }
    }
  }
  .alert_mess {
    width: 300px;
    height: 320px;
    box-sizing: border-box;
    padding: 5px;
    text-align: center;
    // border: 1px solid black;
    box-shadow: 0px 0px 51px 0px #c1c6cb;
    background: white;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    margin: auto;
    z-index: 99;

    .close {
      float: right;
      width: 24px;
      height: 24px;
      position: absolute;
      right: 15px;
      top: 15px;
    }
    .qrcode {
      width: 200px;
      height: 200px;
      margin: 26px 40px 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    p {
      font-size: 16px;
      font-family: Microsoft YaHei;
      margin-top: 21px;
      font-weight: 400;
      color: #333333;
      line-height: 33px;
    }
  }
  .nodata {
    text-align: center;
    margin: 0 auto;
    .button {
      width: 88px;
      height: 32px;
      background: #006fb8;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 32px;
      text-align: center;
      margin: 20px auto;
      border-radius: 4px;
      cursor: pointer;
    }
  }
}
</style>
